module.exports = __webpack_public_path__ + "img/20191214143555565.46184e4d.jpg";